// ========================= Placeholder ==========================
const genEmptyStyle = token => {
  const {
    componentCls
  } = token;
  return {
    ["".concat(componentCls, "-wrapper")]: {
      ["".concat(componentCls, "-tbody > tr").concat(componentCls, "-placeholder")]: {
        textAlign: 'center',
        color: token.colorTextDisabled,
        ["\n          &:hover > th,\n          &:hover > td,\n        "]: {
          background: token.colorBgContainer
        }
      }
    }
  };
};
export default genEmptyStyle;